const handleClickRecordDetails = async (id) => {
  window.open(`/ark:/61903/${id}`, '_blank') || window.location.assign(`/ark:/61903/${id}`)
}

export default handleClickRecordDetails
